<template>
    <div class="home">
      <BookingAppointmentPage />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import BookingAppointmentPage from '@/components/Booking/BookingAppointmentPage.vue'
  
  export default {
    name: 'BookingAppointmentView',
    components: {
      BookingAppointmentPage
    }
  }
  </script>